import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons"

export const EyeSlash = (props) => {
  return <FontAwesomeIcon faIcon={faEyeSlash} {...props} />
}
